import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { TableBodyRoot } from './TableBodyStyles';
import TableComponentsContext from '../Table/TableComponentsContext';
import { conditionalClassNames } from '../../../../UtilityComponents/Util';

const tableComponent = {
	variant: 'body'
};

/**
 *
 * @param {Object} classes - {
 * root - Class applied to all TableHead
 * }
 */

const TableBody = ({ classes = {}, forwardedRef, ...other }) => {
	const { root = '' } = classes;
	const className = conditionalClassNames({
		[root]: root
	});

	return (
		<TableComponentsContext.Provider value={tableComponent}>
			<TableBodyRoot
				className={className}
				ref={forwardedRef}
				{...other}
			/>
		</TableComponentsContext.Provider>
	);
};

TableBody.propTypes = {
	classes: PropTypes.object
};

export default forwardRef((props, ref) => <TableBody {...props} forwardedRef={ref} />);
